export const selectorError = (state) => state.error;

export default selectorError;



// WEBPACK FOOTER //
// ./src/redux/selectors/error.js